import { Box, FormErrorMessage, Text } from '@ksyos/design-system';
import type { ValidationErrors } from '@frontend/utils';
import { getValidationErrorTranslation } from '@frontend/utils';
import type { CheckboxItem } from './HolterMedicationSelector';
import { MedicationCheckbox } from './MedicationCheckbox';

export function MedicationSubItemCheckboxes(
    props: Readonly<{
        ariaLabel: string;
        checkBoxItems: CheckboxItem[];
        errors: ValidationErrors;
        name?: string;
        subTitle?: string;
    }>
) {
    const { checkBoxItems, errors, ariaLabel, name, subTitle } = props;

    return (
        <>
            {subTitle && (
                <Box
                    display="flex"
                    flexDirection="column"
                    key={`subitem-${name}-${subTitle}`}
                    pl={8}
                >
                    <Text
                        fontSize="sm"
                        fontWeight="bold"
                    >
                        {subTitle}
                    </Text>
                </Box>
            )}
            <Box
                display="flex"
                flexDirection="column"
                gap={2}
                key={`subitem-${name}`}
                marginBottom={1}
                pl={8}
            >
                {checkBoxItems.map((checkBoxItem) => (
                    <MedicationCheckbox
                        ariaLabel={ariaLabel}
                        checkBoxItem={checkBoxItem}
                        key={checkBoxItem.checkboxLabel}
                    />
                ))}
                {name && errors.has(`medication.${name}`) && (
                    <FormErrorMessage>
                        {getValidationErrorTranslation(errors.get(`medication.${name}`))}
                    </FormErrorMessage>
                )}
            </Box>
        </>
    );
}
